import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixBookingsServicesV2AddOnGroupsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/services-2',
        destPath: '',
      },
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
      {
        srcPath: '/bookings/services/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    _: [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/services-2',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveWixBookingsServicesV2ServicesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/services-2',
        destPath: '',
      },
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
      {
        srcPath: '/bookings/services/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
      {
        srcPath: '/_api/bookings/v2/bulk/services',
        destPath: '/v2/bulk/services',
      },
    ],
    _: [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/bookings/v2/services',
        destPath: '/v2/services',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/services-2',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_bookings_services';

/**
 * Creates a service.
 *
 *
 * ### Required fields
 *
 * When creating a service you must specify the following fields:
 * - [`type`](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-types):
 * Whether it's an appointment-based service, class, or course.
 * - `name`: Service name that's displayed to customers.
 * - `onlineBooking`:
 * Settings determining whether customers can book online, whether the business
 * must manually confirm bookings, and whether customers can request to book an
 * appointment time slot that already has a booking request awaiting business
 * confirmation.
 * - [`payment`](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-payments):
 * How customers can pay when signing up for the service.
 * - `defaultCapacity`: The maximum number of customers that can book the service. Required for all service types.
 * - For appointment-based services, it must be `1`.
 * - For classes, set to the maximum number of participants per session.
 * - For courses, set to the maximum number of participants for the course.
 *
 * ### Category
 *
 * Set `category.id` to assign the service to a [category](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/categories/introduction).
 * Without an assigned category, the service isn't visible on the live site.
 *
 * ### Online booking
 *
 * Set `onlineBooking.enabled` to `true` so customers can book the service online.
 * When enabled, the service is included in the [single-service booking flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/flow-single-service-booking).
 *
 * ### Approval
 *
 * Set `onlineBooking.requireManualApproval` to control whether bookings need business approval before confirmation.
 * Services with manual approval enabled can't accept pricing plan payments.
 *
 * ### Payment
 *
 * Set `payment.rateType` to `FIXED`, `VARIED`, `CUSTOM`, or `NO_FEE` and specify the corresponding rate details:
 * - `FIXED`: Set `payment.fixed.price`.
 * - `VARIED`: Set `payment.varied.defaultPrice`.
 * - `CUSTOM`: Set `payment.custom.description`.
 * - `NO_FEE`: No additional rate details required.
 *
 * Configure `payment.options` to control how customers can pay:
 * - `online`: Customers can pay online. Requires `rateType` of `FIXED` or `VARIED`.
 * - `inPerson`: Customers can pay in person.
 * - `deposit`: A deposit is required to book. Requires `rateType` of `FIXED` or `VARIED` and a `deposit` amount in the rate details.
 * - `pricingPlan`: Customers can pay using a [pricing plan](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/plans/introduction).
 * Can't be used in combination with manual approval.
 *
 * Learn more about [service payments](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-payments).
 *
 * ### Session durations
 *
 * Depending on which type of service you're creating, you may also need to specify
 * supported session durations.
 *
 * __Classes and courses__
 *
 * Don't specify `schedule.availabilityConstraints.sessionDurations`.
 *
 * __Appointment-based services without varied pricing based on session length__
 *
 * Specify the single supported session duration in the
 * `schedule.availabilityConstraints.sessionDurations` array.
 *
 * __Appointment-based services with varied pricing based on session length__
 *
 * - Specify all supported session durations in `schedule.availabilityConstraints.sessionDurations`.
 * - Note that Wix Bookings doesn't display these values to customers and
 * ignores them in pricing and availability calculations. Instead session
 * durations are retrieved from the relevant [service variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction).
 * - It is mandatory to specify `schedule.availabilityConstraints.sessionDurations`,
 * even though these values are ignored.
 *
 * ### Buffer time
 *
 * For appointment-based services, you can set `schedule.availabilityConstraints.timeBetweenSessions` to add buffer time between booked sessions.
 *
 * ### Locations
 *
 * Set the service's location types and options. You can set 1, some, or all types simultaneously. See [About service locations](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-locations) for details.
 *
 * ### Media
 *
 * Specify `media` so customers see images when selecting the service.
 * Set `media.mainMedia` as the primary image and optionally `media.coverMedia` or `media.items`.
 * Each item is an image with `id`, `height`, and `width`, and optionally `url` and `altText`.
 * Refer to the [Media Manager API](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) for details about uploading images and retrieving their IDs.
 *
 * ### Add-on groups
 *
 * Don't specify existing add-on groups when calling Create Service.
 * Instead, use dedicated add-on group and add-on creation methods to ensure proper validation and maintain referential integrity between services and their optional extras.
 * You can follow this [sample flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/sample-flows#create-bookable-add-ons-for-a-new-group) to create bookable add-ons.
 */
export function createService(payload: object): RequestOptionsFactory<any> {
  function __createService({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'service.createdDate' },
          { path: 'service.updatedDate' },
          { path: 'service.media.items.image.urlExpirationDate' },
          { path: 'service.media.mainMedia.image.urlExpirationDate' },
          { path: 'service.media.coverMedia.image.urlExpirationDate' },
          { path: 'service.payment.subscription.recurringStartDate' },
          { path: 'service.bookingPolicy.createdDate' },
          { path: 'service.bookingPolicy.updatedDate' },
          { path: 'service.schedule.firstSessionStart' },
          { path: 'service.schedule.lastSessionEnd' },
          { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
          {
            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
          },
          { path: 'service.supportedSlugs.createdDate' },
          { path: 'service.mainSlug.createdDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'service.locations.business.address.geocode.latitude' },
          { path: 'service.locations.business.address.geocode.longitude' },
          { path: 'service.locations.custom.address.geocode.latitude' },
          { path: 'service.locations.custom.address.geocode.longitude' },
          { path: 'service.locations.calculatedAddress.geocode.latitude' },
          { path: 'service.locations.calculatedAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.CreateService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createService;
}

/**
 * Creates multiple services.
 *
 *
 * See [Create Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/create-service) for more details.
 */
export function bulkCreateServices(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkCreateServices({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'services.createdDate' },
          { path: 'services.updatedDate' },
          { path: 'services.media.items.image.urlExpirationDate' },
          { path: 'services.media.mainMedia.image.urlExpirationDate' },
          { path: 'services.media.coverMedia.image.urlExpirationDate' },
          { path: 'services.payment.subscription.recurringStartDate' },
          { path: 'services.bookingPolicy.createdDate' },
          { path: 'services.bookingPolicy.updatedDate' },
          { path: 'services.schedule.firstSessionStart' },
          { path: 'services.schedule.lastSessionEnd' },
          { path: 'services.staffMembers.mainMedia.image.urlExpirationDate' },
          {
            path: 'services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
          },
          { path: 'services.supportedSlugs.createdDate' },
          { path: 'services.mainSlug.createdDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'services.locations.business.address.geocode.latitude' },
          { path: 'services.locations.business.address.geocode.longitude' },
          { path: 'services.locations.custom.address.geocode.latitude' },
          { path: 'services.locations.custom.address.geocode.longitude' },
          { path: 'services.locations.calculatedAddress.geocode.latitude' },
          { path: 'services.locations.calculatedAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.BulkCreateServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/bulk/services/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.media.items.image.urlExpirationDate' },
              { path: 'results.item.media.mainMedia.image.urlExpirationDate' },
              { path: 'results.item.media.coverMedia.image.urlExpirationDate' },
              { path: 'results.item.payment.subscription.recurringStartDate' },
              { path: 'results.item.bookingPolicy.createdDate' },
              { path: 'results.item.bookingPolicy.updatedDate' },
              { path: 'results.item.schedule.firstSessionStart' },
              { path: 'results.item.schedule.lastSessionEnd' },
              {
                path: 'results.item.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'results.item.supportedSlugs.createdDate' },
              { path: 'results.item.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.locations.business.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.business.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateServices;
}

/** Retrieves a service. */
export function getService(payload: object): RequestOptionsFactory<any> {
  function __getService({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'GET' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.GetService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getService;
}

/**
 * Updates a service.
 *
 *
 * Each time the service is updated, `revision` increments by 1. You must
 * include the number of the existing revision when updating the service.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 *
 * ### Session durations
 *
 * Specify `schedule.availabilityConstraints.sessionDurations`
 * only if you want to update it for appointment-based services without varied
 * pricing based on session length. Don't specify `schedule.availabilityConstraints.sessionDurations`
 * for all other appointment-based services, classes, or courses. See [Create Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/create-service#session-durations) for more details.
 *
 * ### Service locations
 *
 * Don't call Update Service to adjust service locations, call [Set Service Locations](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-service-locations) instead.
 *
 * ### Add-on groups
 *
 * Don't use Update Service to modify service add-on groups. Use these dedicated methods instead:
 * - **Update add-on group properties**: Call Update Add On Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group)).
 * - **Update add-on display order**: Call Set Add Ons For Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group)).
 */
export function updateService(payload: object): RequestOptionsFactory<any> {
  function __updateService({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'service.createdDate' },
          { path: 'service.updatedDate' },
          { path: 'service.media.items.image.urlExpirationDate' },
          { path: 'service.media.mainMedia.image.urlExpirationDate' },
          { path: 'service.media.coverMedia.image.urlExpirationDate' },
          { path: 'service.payment.subscription.recurringStartDate' },
          { path: 'service.bookingPolicy.createdDate' },
          { path: 'service.bookingPolicy.updatedDate' },
          { path: 'service.schedule.firstSessionStart' },
          { path: 'service.schedule.lastSessionEnd' },
          { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
          {
            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
          },
          { path: 'service.supportedSlugs.createdDate' },
          { path: 'service.mainSlug.createdDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'service.locations.business.address.geocode.latitude' },
          { path: 'service.locations.business.address.geocode.longitude' },
          { path: 'service.locations.custom.address.geocode.latitude' },
          { path: 'service.locations.custom.address.geocode.longitude' },
          { path: 'service.locations.calculatedAddress.geocode.latitude' },
          { path: 'service.locations.calculatedAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'PATCH' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.UpdateService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{service.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateService;
}

/**
 * Updates up to 100 services.
 *
 *
 * See [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service)
 * for more details.
 *
 * The call succeeds even if one or more individual services can't be updated.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkUpdateServices(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateServices({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'services.mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'services.service.createdDate' },
          { path: 'services.service.updatedDate' },
          { path: 'services.service.media.items.image.urlExpirationDate' },
          { path: 'services.service.media.mainMedia.image.urlExpirationDate' },
          { path: 'services.service.media.coverMedia.image.urlExpirationDate' },
          { path: 'services.service.payment.subscription.recurringStartDate' },
          { path: 'services.service.bookingPolicy.createdDate' },
          { path: 'services.service.bookingPolicy.updatedDate' },
          { path: 'services.service.schedule.firstSessionStart' },
          { path: 'services.service.schedule.lastSessionEnd' },
          {
            path: 'services.service.staffMembers.mainMedia.image.urlExpirationDate',
          },
          {
            path: 'services.service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
          },
          { path: 'services.service.supportedSlugs.createdDate' },
          { path: 'services.service.mainSlug.createdDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'services.service.locations.business.address.geocode.latitude',
          },
          {
            path: 'services.service.locations.business.address.geocode.longitude',
          },
          {
            path: 'services.service.locations.custom.address.geocode.latitude',
          },
          {
            path: 'services.service.locations.custom.address.geocode.longitude',
          },
          {
            path: 'services.service.locations.calculatedAddress.geocode.latitude',
          },
          {
            path: 'services.service.locations.calculatedAddress.geocode.longitude',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/bulk/services/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.media.items.image.urlExpirationDate' },
              { path: 'results.item.media.mainMedia.image.urlExpirationDate' },
              { path: 'results.item.media.coverMedia.image.urlExpirationDate' },
              { path: 'results.item.payment.subscription.recurringStartDate' },
              { path: 'results.item.bookingPolicy.createdDate' },
              { path: 'results.item.bookingPolicy.updatedDate' },
              { path: 'results.item.schedule.firstSessionStart' },
              { path: 'results.item.schedule.lastSessionEnd' },
              {
                path: 'results.item.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'results.item.supportedSlugs.createdDate' },
              { path: 'results.item.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.locations.business.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.business.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateServices;
}

/**
 * Updates multiple services by filter.
 *
 *
 * See [Query Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/query-services) for a list of supported filters.
 *
 * See [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service) for more details about updating a service.
 *
 * The call succeeds even if one or more individual services can't be updated.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkUpdateServicesByFilter(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateServicesByFilter({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'service.createdDate' },
          { path: 'service.updatedDate' },
          { path: 'service.media.items.image.urlExpirationDate' },
          { path: 'service.media.mainMedia.image.urlExpirationDate' },
          { path: 'service.media.coverMedia.image.urlExpirationDate' },
          { path: 'service.payment.subscription.recurringStartDate' },
          { path: 'service.bookingPolicy.createdDate' },
          { path: 'service.bookingPolicy.updatedDate' },
          { path: 'service.schedule.firstSessionStart' },
          { path: 'service.schedule.lastSessionEnd' },
          { path: 'service.staffMembers.mainMedia.image.urlExpirationDate' },
          {
            path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
          },
          { path: 'service.supportedSlugs.createdDate' },
          { path: 'service.mainSlug.createdDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'service.locations.business.address.geocode.latitude' },
          { path: 'service.locations.business.address.geocode.longitude' },
          { path: 'service.locations.custom.address.geocode.latitude' },
          { path: 'service.locations.custom.address.geocode.longitude' },
          { path: 'service.locations.calculatedAddress.geocode.latitude' },
          { path: 'service.locations.calculatedAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.ServicesService.BulkUpdateServicesByFilter',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/bulk/services/update-by-filter',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __bulkUpdateServicesByFilter;
}

/**
 * Deletes a service.
 *
 *
 * Specify `{"preserveFutureSessionsWithParticipants": true}` to retain all
 * future sessions for the service. By default, all future sessions are canceled.
 */
export function deleteService(payload: object): RequestOptionsFactory<any> {
  function __deleteService({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'DELETE' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.DeleteService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteService;
}

/**
 * Deletes multiple services.
 *
 *
 * See [Delete Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/delete-service)
 * for more details about deleting a service.
 *
 * The call succeeds even if one or more individual services can't be deleted.
 * Information about failures is returned in `bulkActionMetadata`.
 */
export function bulkDeleteServices(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkDeleteServices({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/bulk/services/delete',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.media.items.image.urlExpirationDate' },
              { path: 'results.item.media.mainMedia.image.urlExpirationDate' },
              { path: 'results.item.media.coverMedia.image.urlExpirationDate' },
              { path: 'results.item.payment.subscription.recurringStartDate' },
              { path: 'results.item.bookingPolicy.createdDate' },
              { path: 'results.item.bookingPolicy.updatedDate' },
              { path: 'results.item.schedule.firstSessionStart' },
              { path: 'results.item.schedule.lastSessionEnd' },
              {
                path: 'results.item.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'results.item.supportedSlugs.createdDate' },
              { path: 'results.item.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.locations.business.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.business.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.latitude',
              },
              {
                path: 'results.item.locations.custom.address.geocode.longitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'results.item.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkDeleteServices;
}

/**
 * Deletes multiple services by filter.
 *
 *
 * See [Delete Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/delete-service)
 * for more details about deleting a service.
 *
 * The call succeeds even if one or more individual services can't be deleted.
 * Information about failures is returned in `bulkActionMetadata`.
 *
 * Refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/introduction#services-filtering-and-sorting)
 * for more details.
 *
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
 */
export function bulkDeleteServicesByFilter(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkDeleteServicesByFilter({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.ServicesService.BulkDeleteServicesByFilter',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/bulk/services/delete-by-filter',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkDeleteServicesByFilter;
}

/**
 * Creates a query to retrieve a list of `service` objects.
 *
 * The `queryServices()` function builds a query to retrieve a list of `service` objects and returns a `ServicesQueryBuilder` object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the [find()](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/services-query-builder/find) function.
 *
 * You can refine the query by chaining `ServicesQueryBuilder` functions onto the query. `ServicesQueryBuilder` functions enable you to sort, filter, and control the results that `queryServices()` returns.
 *
 * `queryServices()` runs with the following `ServicesQueryBuilder` defaults that you can override:
 *
 * + `limit` is `100`.
 * + Sorted by `createdDate` in ascending order.
 *
 * The functions that are chained to `queryServices()` are applied in the order they are called. For example, if you apply `ascending("category.name")` and then `ascending("name")`, the results are sorted first by `category.name`, and then, if there are multiple results with the same `category.name`, the items are sorted by `name`.
 *
 * The following `ServicesQueryBuilder` functions are supported for the `queryServices()` function. For a full description of the `service` object, see the object returned for the [items](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/services-query-result/items) property in `ServicesQueryResult`.
 */
export function queryServices(payload: object): RequestOptionsFactory<any> {
  function __queryServices({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'services.createdDate' },
              { path: 'services.updatedDate' },
              { path: 'services.media.items.image.urlExpirationDate' },
              { path: 'services.media.mainMedia.image.urlExpirationDate' },
              { path: 'services.media.coverMedia.image.urlExpirationDate' },
              { path: 'services.payment.subscription.recurringStartDate' },
              { path: 'services.bookingPolicy.createdDate' },
              { path: 'services.bookingPolicy.updatedDate' },
              { path: 'services.schedule.firstSessionStart' },
              { path: 'services.schedule.lastSessionEnd' },
              {
                path: 'services.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'services.supportedSlugs.createdDate' },
              { path: 'services.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'services.locations.business.address.geocode.latitude' },
              { path: 'services.locations.business.address.geocode.longitude' },
              { path: 'services.locations.custom.address.geocode.latitude' },
              { path: 'services.locations.custom.address.geocode.longitude' },
              { path: 'services.locations.calculatedAddress.geocode.latitude' },
              {
                path: 'services.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryServices;
}

/**
 * Retrieves a list of up to 100 services, given the provided filtering, paging,
 * and sorting.
 *
 *
 * ### Defaults
 *
 * Search Services has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `paging.limit` set to `100`.
 * + `paging.offset` set to `0`.
 *
 * ### Filters
 *
 * When using filters for dates, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Search methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language) and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 */
export function searchServices(payload: object): RequestOptionsFactory<any> {
  function __searchServices({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'search.aggregations.range.buckets.from' },
          { path: 'search.aggregations.range.buckets.to' },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.from',
          },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.to',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.SearchServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/search',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'services.createdDate' },
              { path: 'services.updatedDate' },
              { path: 'services.media.items.image.urlExpirationDate' },
              { path: 'services.media.mainMedia.image.urlExpirationDate' },
              { path: 'services.media.coverMedia.image.urlExpirationDate' },
              { path: 'services.payment.subscription.recurringStartDate' },
              { path: 'services.bookingPolicy.createdDate' },
              { path: 'services.bookingPolicy.updatedDate' },
              { path: 'services.schedule.firstSessionStart' },
              { path: 'services.schedule.lastSessionEnd' },
              {
                path: 'services.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'services.supportedSlugs.createdDate' },
              { path: 'services.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'services.locations.business.address.geocode.latitude' },
              { path: 'services.locations.business.address.geocode.longitude' },
              { path: 'services.locations.custom.address.geocode.latitude' },
              { path: 'services.locations.custom.address.geocode.longitude' },
              { path: 'services.locations.calculatedAddress.geocode.latitude' },
              {
                path: 'services.locations.calculatedAddress.geocode.longitude',
              },
              { path: 'aggregationData.results.ranges.results.from' },
              { path: 'aggregationData.results.ranges.results.to' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.from',
              },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.to',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.from',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.to',
              },
              { path: 'aggregationData.results.scalar.value' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.scalar.value',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.scalar.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __searchServices;
}

/**
 * Retrieves a list of up to 100 [booking policies](https://dev.wix.com/docs/api-reference/business-solutions/bookings/policies/booking-policies/introduction),
 * and information about the services that are connected to them,
 * given the provided filtering, paging, and sorting.
 *
 * ### Defaults
 *
 * Query Policies has the following default settings, which you can override:
 *
 * + Sorted by `id` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ### Filters
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### Returned services
 *
 * If a booking policy is connected to more than 5 services, only a subset of
 * those services is returned. The `bookingPolicies.totalServiceCount` values
 * indicate the total number of services linked to each policy. You can call [Search Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/search-services)
 * and specify the relevant policy ID in the filter to retrieve all services
 * connected to the booking policy.
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryPolicies(payload: object): RequestOptionsFactory<any> {
  function __queryPolicies({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.QueryPolicies',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/policies/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'bookingPolicies.bookingPolicy.createdDate' },
              { path: 'bookingPolicies.bookingPolicy.updatedDate' },
              { path: 'bookingPolicies.services.createdDate' },
              { path: 'bookingPolicies.services.updatedDate' },
              {
                path: 'bookingPolicies.services.media.items.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.services.media.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.services.media.coverMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.services.payment.subscription.recurringStartDate',
              },
              { path: 'bookingPolicies.services.bookingPolicy.createdDate' },
              { path: 'bookingPolicies.services.bookingPolicy.updatedDate' },
              { path: 'bookingPolicies.services.schedule.firstSessionStart' },
              { path: 'bookingPolicies.services.schedule.lastSessionEnd' },
              {
                path: 'bookingPolicies.services.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.services.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'bookingPolicies.services.supportedSlugs.createdDate' },
              { path: 'bookingPolicies.services.mainSlug.createdDate' },
              { path: 'bookingPolicies.connectedServices.createdDate' },
              { path: 'bookingPolicies.connectedServices.updatedDate' },
              {
                path: 'bookingPolicies.connectedServices.media.items.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.connectedServices.media.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.connectedServices.media.coverMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.connectedServices.payment.subscription.recurringStartDate',
              },
              {
                path: 'bookingPolicies.connectedServices.bookingPolicy.createdDate',
              },
              {
                path: 'bookingPolicies.connectedServices.bookingPolicy.updatedDate',
              },
              {
                path: 'bookingPolicies.connectedServices.schedule.firstSessionStart',
              },
              {
                path: 'bookingPolicies.connectedServices.schedule.lastSessionEnd',
              },
              {
                path: 'bookingPolicies.connectedServices.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.connectedServices.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'bookingPolicies.connectedServices.supportedSlugs.createdDate',
              },
              {
                path: 'bookingPolicies.connectedServices.mainSlug.createdDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'bookingPolicies.services.locations.business.address.geocode.latitude',
              },
              {
                path: 'bookingPolicies.services.locations.business.address.geocode.longitude',
              },
              {
                path: 'bookingPolicies.services.locations.custom.address.geocode.latitude',
              },
              {
                path: 'bookingPolicies.services.locations.custom.address.geocode.longitude',
              },
              {
                path: 'bookingPolicies.services.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'bookingPolicies.services.locations.calculatedAddress.geocode.longitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.business.address.geocode.latitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.business.address.geocode.longitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.custom.address.geocode.latitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.custom.address.geocode.longitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'bookingPolicies.connectedServices.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryPolicies;
}

/**
 * Retrieves a list of up to 100 booking [forms](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/form-object),
 * and information about the services that are connected to them,
 * given the provided filtering, paging, and sorting.
 *
 *
 * ### Defaults
 *
 * Query Booking Forms has the following default settings, which you can override:
 *
 * + Sorted by `id` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ### Filters
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### Returned services
 *
 * If a booking policy is connected to more than 5 services, only a subset of
 * these service IDs and names is returned. The `bookingForms.totalServiceCount`
 * values indicate the total number of services linked to each form. You can call [Query Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/query-services)
 * and specify the relevant form ID in the filter to retrieve all services
 * connected to the booking form.
 *
 * ### Default booking forms
 *
 * By default, all Wix Bookings services use a standard booking form. To retrieve
 * a site's default booking form with Query Booking Forms, specify
 * `{"conditionalFields": ["DEFAULT_BOOKING_FORM"]}`.
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryBookingForms(payload: object): RequestOptionsFactory<any> {
  function __queryBookingForms({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.QueryBookingForms',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/booking-forms/query',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __queryBookingForms;
}

/**
 * Counts how many services match the given filter.
 *
 *
 * See [Query Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/query-services) for a list of supported filters.
 *
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)
 */
export function countServices(payload: object): RequestOptionsFactory<any> {
  function __countServices({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.CountServices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/count',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __countServices;
}

/**
 * Retrieves 3 separate lists of business, custom, and customer [locations](https://dev.wix.com/docs/api-reference/business-management/locations/introduction),
 * given the provided filtering, and whether each location is connected to at
 * least one of the site's services.
 *
 *
 * ### Defaults
 *
 * Query Locations has the following default setting, which you can't override:
 * Sorted by `id` in ascending order.
 *
 * ### Filters
 *
 * For a complete list of supported filters, refer to the `location` object
 * ([REST](https://dev.wix.com/docs/rest/business-management/locations/location-object)).
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryLocations(payload: object): RequestOptionsFactory<any> {
  function __queryLocations({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.QueryLocations',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/locations/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'businessLocations.locations.business.address.geocode.latitude',
              },
              {
                path: 'businessLocations.locations.business.address.geocode.longitude',
              },
              {
                path: 'businessLocations.locations.custom.address.geocode.latitude',
              },
              {
                path: 'businessLocations.locations.custom.address.geocode.longitude',
              },
              {
                path: 'businessLocations.locations.calculatedAddress.geocode.latitude',
              },
              {
                path: 'businessLocations.locations.calculatedAddress.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryLocations;
}

/**
 * Retrieves a list of [service categories](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/categories-v2/introduction), given the provided filtering.
 *
 *
 * ### Defaults
 *
 * Query Categories has the following default setting, which you can't override:
 * Sorted by `id` in ascending order.
 *
 * ### Filters
 *
 * When using date filters, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 */
export function queryCategories(payload: object): RequestOptionsFactory<any> {
  function __queryCategories({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.QueryCategories',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/categories/query',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __queryCategories;
}

/**
 * Replaces the list of the [locations](https://dev.wix.com/docs/api-reference/business-management/locations/introduction) where the business offers the service.
 *
 *
 * ### Consequences for customers
 *
 * Removing a service location may impact existing sessions and their
 * participants. If you remove at least one service location, you must
 * specify `removedLocationSessionsAction` to indicate what happens to all
 * future sessions scheduled at this location.
 *
 * - **Keep existing location**: If you want to retain future sessions at their
 * originally scheduled location, specify
 * `{"removedLocationSessionsAction.action": "KEEP_AT_CURRENT_LOCATION"}`.
 * This ensures nothing changes for the customer, but the business must be
 * able to provide access to the removed location in the future.
 * - **Update location**: If you want to update the location for future sessions
 * scheduled at the removed location, specify
 * `{"removedLocationSessionsAction.action": "MOVE_TO_LOCATION"}` and
 * `moveToLocationOptions.newLocation`.
 *
 * You can't mix and match to keep some sessions at the previous location while
 * moving other sessions to an updated location.
 *
 * Past session details aren't changed, no matter which option you choose for
 * future sessions.
 *
 * Future sessions scheduled for a location defined by the customer are also not
 * updated.
 *
 * ### Specify location details
 *
 * Depending on whether the new or updated location is a business or custom location,
 * you need to specify different fields.
 *
 * - **Business location**: Specify the relevant [location ID](https://dev.wix.com/docs/api-reference/business-management/locations/introduction) in `locations.business.id`.
 * - **Custom location**: Specify the complete address object as
 * `locations.custom.address`.
 *
 * ### Participant notifications
 *
 * You can specify a `participantNotification.message` that's immediately send
 * to all customers who had booked at a changed location. Ensure
 * `participantNotification.notifyParticipants` is set to `true` to send the
 * message.
 */
export function setServiceLocations(
  payload: object
): RequestOptionsFactory<any> {
  function __setServiceLocations({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'locations.business.address.geocode.latitude' },
          { path: 'locations.business.address.geocode.longitude' },
          { path: 'locations.custom.address.geocode.latitude' },
          { path: 'locations.custom.address.geocode.longitude' },
          { path: 'locations.calculatedAddress.geocode.latitude' },
          { path: 'locations.calculatedAddress.geocode.longitude' },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.business.address.geocode.latitude',
          },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.business.address.geocode.longitude',
          },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.custom.address.geocode.latitude',
          },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.custom.address.geocode.longitude',
          },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.calculatedAddress.geocode.latitude',
          },
          {
            path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.calculatedAddress.geocode.longitude',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.SetServiceLocations',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}/locations',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __setServiceLocations;
}

/**
 * Adds a list of [pricing plan IDs](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/plans/plans-v3/introduction) to a service's `payment.pricingPlanIds` array.
 *
 *
 * The call doesn't validate whether the service's `payment.options.pricingPlan`
 * is set to `true`. If it's set to `false`, customers aren't able to pay
 * for their bookings using pricing plans. You can call [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service) to change a service's supported payment methods.
 */
export function enablePricingPlansForService(
  payload: object
): RequestOptionsFactory<any> {
  function __enablePricingPlansForService({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.ServicesService.EnablePricingPlansForService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}/pricing-plans/add',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __enablePricingPlansForService;
}

/**
 * Removes a list of [pricing plan IDs](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/plans/introduction) from a service's `payment.pricingPlanIds` array.
 *
 *
 * If you remove all pricing plan IDs from `payment.pricingPlanIds` and the
 * service supports only payments by pricing plan, customers will no longer be
 * able to book the service, as they will have no payment options available.
 */
export function disablePricingPlansForService(
  payload: object
): RequestOptionsFactory<any> {
  function __disablePricingPlansForService({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.ServicesService.DisablePricingPlansForService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}/pricing-plans/remove',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __disablePricingPlansForService;
}

/**
 * Sets a new active slug for the service.
 *
 *
 * The call fails if at least one of these conditions is met:
 * - The slug doesn't adheres to the supported format.
 * - Another service is currently using the slug.
 * - Another service has used the slug in the past.
 */
export function setCustomSlug(payload: object): RequestOptionsFactory<any> {
  function __setCustomSlug({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.SetCustomSlug',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/{serviceId}/slugs/custom',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'slug.createdDate' },
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __setCustomSlug;
}

/**
 * Checks whether a custom slug is validate for the service.
 *
 *
 * The checks include:
 * - The slug adheres to the supported format.
 * - No other service is currently using the slug.
 * - No other service has used the slug in the past.
 *
 * The call fails if at least one of the checks fails.
 */
export function validateSlug(payload: object): RequestOptionsFactory<any> {
  function __validateSlug({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.ValidateSlug',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/slugs/validate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __validateSlug;
}

/**
 * Clones a service.
 *
 *
 * ### Connected entities
 *
 * By default, not all entities connected to the service are cloned.
 *
 * #### Schedule
 *
 * Wix Bookings automatically creates a new active [schedule](https://dev.wix.com/docs/api-reference/business-management/calendar/schedules-v3/introduction)
 * for the cloned service. If Wix Bookings can't create this schedule, the
 * Clone Service call fails.
 *
 * - __For appointment-based services__: Future appointments aren't added to the
 * cloned service's schedule. Use the [Events API](https://dev.wix.com/docs/api-reference/business-management/calendar/events-v3/introduction) to add them as needed.
 * - __For classes and courses__: Future one-time events aren't added to the
 * cloned service's schedule, while future recurring events are added
 * asynchronously. The Clone Service call always succeeds, whether or not
 * recurring events are added.
 * If the response includes `RECURRING_EVENTS` in the `errors` array, it means the
 * cloned service doesn't have future recurring events, even though the original
 * service does. You can either delete the cloned service and try again or use
 * the [Events API](https://dev.wix.com/docs/api-reference/business-management/calendar/events-v3/introduction) to add missing events to the schedule.
 *
 * Wix Bookings never adds past events to the cloned service's schedule.
 *
 * #### Service options and variants
 *
 * If the original service has [variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction),
 * they're cloned asynchronously. The Clone Service call always succeeds,
 * regardless of whether variants were cloned.
 *
 * If the response includes `OPTIONS_AND_VARIANTS` in the `errors` array, the cloned
 * service doesn't have variants, even though the original service does. You can
 * delete the cloned service and call Clone Service again, or use the
 * [Service Options And Variants API](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction) to add variants.
 *
 * #### Booking form
 *
 * The original service's booking form isn't cloned, whether it's
 * the default or a custom booking form.
 *
 * #### Pricing plans
 *
 * If the original service's accepts payments via [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/introduction/),
 * the cloned service's `payment.options.pricingPlan` is also set to `true`. To
 * accept specific pricing plans, call [Enable Pricing Plans For Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/enable-pricing-plans-for-service),
 * after cloning the service. If the original service accepts only
 * pricing plan payments and you don't call Enable Pricing Plans For Service
 * after cloning the service, customers will be unable to book the service.
 */
export function cloneService(payload: object): RequestOptionsFactory<any> {
  function __cloneService({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.ServicesService.CloneService',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2ServicesServiceUrl({
        protoPath: '/v2/services/clone',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'service.createdDate' },
              { path: 'service.updatedDate' },
              { path: 'service.media.items.image.urlExpirationDate' },
              { path: 'service.media.mainMedia.image.urlExpirationDate' },
              { path: 'service.media.coverMedia.image.urlExpirationDate' },
              { path: 'service.payment.subscription.recurringStartDate' },
              { path: 'service.bookingPolicy.createdDate' },
              { path: 'service.bookingPolicy.updatedDate' },
              { path: 'service.schedule.firstSessionStart' },
              { path: 'service.schedule.lastSessionEnd' },
              {
                path: 'service.staffMembers.mainMedia.image.urlExpirationDate',
              },
              {
                path: 'service.staffMemberDetails.staffMembers.mainMedia.image.urlExpirationDate',
              },
              { path: 'service.supportedSlugs.createdDate' },
              { path: 'service.mainSlug.createdDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'service.locations.business.address.geocode.latitude' },
              { path: 'service.locations.business.address.geocode.longitude' },
              { path: 'service.locations.custom.address.geocode.latitude' },
              { path: 'service.locations.custom.address.geocode.longitude' },
              { path: 'service.locations.calculatedAddress.geocode.latitude' },
              { path: 'service.locations.calculatedAddress.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __cloneService;
}

/** Creates a new add-on group for a service and updates the service's `addOnGroups` array. */
export function createAddOnGroup(payload: object): RequestOptionsFactory<any> {
  function __createAddOnGroup({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.CreateAddOnGroup',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
        protoPath: '/v2/services/add-on-groups/create',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createAddOnGroup;
}

/**
 * Deletes an add-on group.
 *
 *
 * Deleting the group doesn't delete individual add-ons.
 * Any add-on not associated with another group isn't available for customers to book.
 */
export function deleteAddOnGroup(payload: object): RequestOptionsFactory<any> {
  function __deleteAddOnGroup({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.DeleteAddOnGroup',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
        protoPath: '/v2/services/add-on-groups/delete',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __deleteAddOnGroup;
}

/**
 * Updates an add-on group.
 *
 *
 * To update only the display order for add-ons, call [Set Add Ons For Group](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/set-add-ons-for-group) instead.
 *
 * You can't change which service an add-on group belongs to.
 * Each add-on group is permanently associated with the service it was created for.
 * To use the same add-ons with a different service, create a new add-on group for that service.
 */
export function updateAddOnGroup(payload: object): RequestOptionsFactory<any> {
  function __updateAddOnGroup({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn: 'wix.bookings.services.v2.AddOnGroupsService.UpdateAddOnGroup',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
        protoPath: '/v2/services/add-on-groups/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __updateAddOnGroup;
}

/**
 * Retrieves add-on groups for a service with enriched add-on details.
 *
 *
 * Add-on details are returned based on their display order.
 *
 * If you specify `groupIds`, only those groups are returned.
 * By default, all groups associated with the service are returned.
 */
export function listAddOnGroupsByServiceId(
  payload: object
): RequestOptionsFactory<any> {
  function __listAddOnGroupsByServiceId({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.AddOnGroupsService.ListAddOnGroupsByServiceId',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
        protoPath:
          '/v2/services/add-on-groups/list-add-on-groups-by-service-id',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __listAddOnGroupsByServiceId;
}

/**
 * Sets the add-ons for a specific group, replacing any existing add-ons in the group.
 *
 *
 * Call this method when you want to:
 * - Add new add-ons to a group.
 * - Remove add-ons from a group.
 * - Reorder existing add-ons for optimal customer presentation.
 *
 * The order of add-ons in the request determines their display sequence to customers.
 * All specified add-ons must already exist before adding them to a group.
 *
 * For updating other add-on group properties, for example `name`, `prompt`, or `constraints`, call [Update Add On Group](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group) instead.
 */
export function setAddOnsForGroup(payload: object): RequestOptionsFactory<any> {
  function __setAddOnsForGroup({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.services.v2.service',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.services.v2.AddOnGroupsService.SetAddOnsForGroup',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsServicesV2AddOnGroupsServiceUrl({
        protoPath: '/v2/services/add-on-groups/set-add-ons-for-group',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __setAddOnsForGroup;
}
